export const BENEFICIARY_THREE_NAME = "BENEFICIARY_THREE_NAME";
export const BENEFICIARY_NAME_DATE = "BENEFICIARY_NAME_DATE";
export const ACCOUNT_NUMBER = "ACCOUNT_NUMBER";
export const IBAN_NUMBER = "IBAN_NUMBER";
